import {
  NumberOrNullOrUndefined,
} from 'src/app/shared/utils';
import { parseYMDDate } from 'src/app/shared/utils/DateOrNullOrUndefined';
import { formatDateToYmd } from 'src/app/shared/utils/formatDate';
import { PlanV2 } from './plan.v2.model';

export class WeeklyReportV2 {
  id: number = 0;
  plan_id: number = 0;
  week_start: string | Date = '';
  week_end: string | Date = '';
  value: number = 0;
  total_units: number = 0;
  created_at: string | Date = '';
  updated_at: string | Date = '';
  deleted_at: string | Date = '';
  plan?: PlanV2;

  constructor(data: Partial<WeeklyReportV2> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.plan_id = NumberOrNullOrUndefined(data.plan_id) ?? 0;
    this.week_start = WeeklyReportV2.parseDateOnlyValue(data.week_start);
    this.week_end = WeeklyReportV2.parseDateOnlyValue(data.week_end);
    this.value = NumberOrNullOrUndefined(data.value) ?? 0;
    this.total_units = NumberOrNullOrUndefined(data.total_units) ?? 0;
    this.created_at = data.created_at ? new Date(data.created_at) : '';
    this.updated_at = data.updated_at ? new Date(data.updated_at) : '';
    this.deleted_at = data.deleted_at ? new Date(data.deleted_at) : '';
    this.plan = data.plan ? new PlanV2(data.plan) : undefined;
  }

  private static parseDateOnlyValue(value: string | Date | undefined): string | Date | '' {
    if (!value) {
      return '';
    }

    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    const normalized = formatDateToYmd(value);
    if (normalized) {
      return parseYMDDate(normalized);
    }

    return new Date(value);
  }
}
